import React from 'react';
import { Text } from '@perch-labs/shrike';
import { useProductStatus, ProductType } from 'hooks/use-product-status.hook';
import { useParams } from 'react-router-dom';
import { Card } from 'styles';
import { copyFor } from 'config';
import { LoadingModule } from 'components/loading';
import { Accordion } from 'components/accordion';
import { Content } from './content';
import { CardHeader } from './billing-explainer.style';

const getCopy = copyFor('billing.billingExplainer');

interface Props {
  accordion?: boolean;
}

export const BillingExplainer = ({ accordion }: Props) => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, error, loading } = useProductStatus(
    ProductType.Vnm,
    Number(planId)
  );
  const isVnm = data?.isActive || data?.isAvailable || data?.isPending;
  const title = (
    <Text tag="h2" margin="16px 0" textStyle="heading700">
      {getCopy('title')}
    </Text>
  );

  if (loading) return <LoadingModule />;
  if (error || !isVnm) return null;

  return accordion ? (
    <Card mobileVariant="flat" padding="0 16px">
      <Accordion label={title}>
        <Content />
      </Accordion>
    </Card>
  ) : (
    <Card mobileVariant="flat">
      <CardHeader>{title}</CardHeader>
      <Card.Content>
        <Content />
      </Card.Content>
    </Card>
  );
};
